import React, {useContext, useState, createContext, useEffect, useMemo} from "react";
import { Navigate, useNavigate } from "react-router-dom";
import globals from "../globals";
// import { useLocalStorage } from "./LocalStorage";
import { useLocalStorage } from '@uidotdev/usehooks'
import CircularProgress from '@mui/material/CircularProgress';
import LoadingPage from '../error_page/loadingPage'
import { useCart } from "./CartContext";



const AuthContext = createContext();

function getDefaultProfileRoute(user) {
    return user?.role?.toLowerCase() === "admin" ? "/admin-dashboard" : "/dashboard";
}

export const AuthProvider = ({children}) => {
    const {clearCart} = useCart();
    const [user, setUser] = useLocalStorage("user", null);
    const [token, setToken] = useLocalStorage("token", "");

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate()
    
    useEffect(() => {
        setLoading(true);
        if (token) {
        fetch(globals.apiUrl + "/auth/me", {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
        .then(response => {
            //console.log('response', response);
            if (response.status === 200) {
                return response.json();
            }
            if (response.status === 401){
                setLoading(false);
                setUser(null);
                setToken("");
                setIsLoggedIn(false);
                throw new Error('Unauthorized');
            }
            
        })
        .then(response => {
            //console.log('response', response);
            if (response.detail){
                //console.log('here 2')
                //console.log(response.detail);
                setLoading(false);
                // setUser(null);
                // setToken("");
                // setIsLoggedIn(false);
            }
            if (response.status === 403 || response.status === 401){
                //console.log('here 4')
                setLoading(false);
                setIsLoggedIn(false);
                setUser(null);
                setToken("");
            }
            else{
                setUser(response);
                setIsLoggedIn(true);
            }
            setLoading(false);
        })
        .catch(error => {
            //console.log('here 3')
            //console.log(error);
            setLoading(false);
            // setUser(null);
            // setToken("");
            // setIsLoggedIn(false);
            // setLoading(false);
        });
    }else{
        setLoading(false);
    }
    setLoading(false);
    }, [token, user]);

    const login =  (data) => {
        setUser(data.user);
        setToken(data.token);
        setIsLoggedIn(true);
        navigate(getDefaultProfileRoute(data.user));
    }

    const logout = () => {
        setUser(null);
        setToken("");
        setIsLoggedIn(false);
        navigate(0);
        clearCart();
    }

    const isImpersonating = Boolean(user?.impersonator_id);

    const value = useMemo(
        () => ({ user, isLoggedIn, token, login, logout, loading, isImpersonating }),
        [user, isLoggedIn, token, loading, isImpersonating],
    );
    return (
        <AuthContext.Provider value={value}>
            {
                // loading ? <LoadingPage /> : children
                children
            }
        </AuthContext.Provider>
    )
}

export const useAuth = () => {
    return useContext(AuthContext);
}